import { GetProceduresQueryResponse, ProcedureItem } from 'common/types'
import { enqueueSnackbar } from 'notistack'
import { Notification } from 'components/NotificationPopup/NotificationPopup.types'

export const loadNotifications = (
  proceduresResponse?: GetProceduresQueryResponse
) => {
  if (!proceduresResponse) return []
  try {
    const notifications: Notification[] =
      proceduresResponse?.getProcedures?.procedures?.map(
        (item: {
          documentedCount: number
          unDocumentedCount: number
          procedure: ProcedureItem
        }) => {
          const procedure = item.procedure
          return {
            id: item.procedure.id,
            title: `Procedure in Progress`,
            message: `Procedure for surgeon ${procedure.practitioners[0]?.firstName} ${procedure.practitioners[0]?.lastName}, patient ${procedure.patient?.firstName} ${procedure.patient?.lastName} is still open and requires attention.`,
            type: 'warning',
            timestamp: new Date(procedure?.dateTime),
            actionUrl: `/surgeries/${procedure.id}`,
            actionText: 'View Procedure',
            canDismiss: false,
          }
        }
      ) || []

    return notifications
  } catch (error) {
    enqueueSnackbar('Failed to load notifications', { variant: 'error' })
    return []
  }
}
